import React, { useContext } from 'react';
import { Modal } from 'antd';
import TableForm from './TableForm';
import './PageModal.scss';
import CustomersPaymentsProvider from '../../contexts/customers-payments-context/CustomersPaymentsContext';
import { useTranslation } from 'react-i18next';
const PageModal = ({ setAllSuppliersFetchCount }) => {
  const {
    modalOpened,
    setModalOpened,
    selectedCustomerPayment,
    setSelectedCustomerPayment
  } = useContext(CustomersPaymentsProvider);
  const { t } = useTranslation();
  return (
    <Modal
      className="new-supplier-modal"
      width="90%"
      style={{ maxWidth: '642px' }}
      title={t('SupplierPays.MakeNewPayment')}
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedCustomerPayment(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedCustomerPayment(null);
      }}
      footer={false}
    >
      <TableForm setAllSuppliersFetchCount={setAllSuppliersFetchCount} />
    </Modal>
  );
};

export default PageModal;
